module.exports = __webpack_public_path__ + "static/img/A129.66fd7509.jpg";